'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaQuoteRight = function FaQuoteRight(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm18.6 7.1v15.8q0 2.3-0.9 4.4t-2.4 3.6-3.7 2.5-4.4 0.9h-1.4q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.6 0.4-1t1-0.4h1.4q2.4 0 4.1-1.7t1.6-4v-0.8q0-0.8-0.6-1.5t-1.5-0.6h-5q-1.8 0-3.1-1.2t-1.2-3.1v-8.6q0-1.7 1.3-3t3-1.2h8.6q1.7 0 3 1.2t1.2 3z m20 0v15.8q0 2.3-0.9 4.4t-2.4 3.6-3.7 2.5-4.4 0.9h-1.4q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.6 0.4-1t1-0.4h1.4q2.4 0 4.1-1.7t1.6-4v-0.8q0-0.8-0.6-1.5t-1.5-0.6h-5q-1.8 0-3.1-1.2t-1.2-3.1v-8.6q0-1.7 1.3-3t3-1.2h8.6q1.7 0 3 1.2t1.2 3z' })
        )
    );
};

exports.default = FaQuoteRight;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/quote-right.js
// module id = 488
// module chunks = 58411574672382 79611799117203 84521481881339 164655002686464